(function( $ ) {
    'use strict';

    $( window ).load(function() {
        if (window.location.href.indexOf("cart") === -1) {
            // only run this on the cart page
            return;
        }

        const cartContainer = document.querySelector('.table-cart .elementor-container')
        const couponContainer = document.querySelector('#list-cart .js-coupon')

        // set up remove item from cart buttons
        document.addEventListener(
            'click',
            async function (event) {
                if (!event.target.matches('.js-remove')) {
                    return;
                }

                const removeButton = event.target;

                const productId = removeButton.dataset.id;

                if (!productId) {
                    console.error("No product ID found on this remove button");
                    return;
                }

                await window.cart.removeItem(productId);
                renderCart()
            }
        );

        // re-render the cart when the window is resized
        window.matchMedia('(max-width: 767px)').addEventListener(
            'change',
            function() {
                renderCart()
            }
        );




        // renders the correct cart header
        function renderCartHeader() {
            const cartEmpty = document.querySelector('#cart-empty')
            const cartEl = document.querySelector('#list-cart')
            const cartHeading = document.querySelector('#cart-heading .elementor-heading-title')

            if (!cartEl || !cartEmpty || !cartHeading) {
                // all must exist to render this
                return;
            }

            if (!window.cart.isEmpty()) {
                cartEl.style.display = 'block'
                cartEmpty.style.display = 'none'
                cartHeading.textContent = 'Your bag (' + window.cart.getItemCount() + ')'
            } else {
                cartEmpty.style.display = 'block'
                cartEl.style.display = 'none'
                cartHeading.textContent = 'Your bag'
            }
        }

        function renderCartDiscounts() {
            // update sub total
            document.querySelector('.subtotal-cart .elementor-heading-title').textContent = `£${window.cart.getTotalPrice().toFixed(2)}`;
            document.querySelector('.grandtotal-cart .elementor-heading-title').textContent = `£${window.cart.getDiscountedPrice().toFixed(2)}`;

            if (window.cart.areCouponsApplied()) {
                // show the discount details
                couponContainer.style.display = 'block'
                couponContainer.innerHTML = null;

                window.cart.coupons.forEach(function(coupon) {
                    const couponItem = document.createElement('div')
                    couponItem.classList.add('cart-coupon-item');

                    couponItem.innerHTML = `
                        <div class="js-coupon-left">
                            <div class="elementor-heading-title">${coupon.code}</div>
                        </div>
                        <div class="js-coupon-right">
                            <div class="elementor-heading-title">-£${coupon.discountAmount.toFixed(2)}</div>
                        </div>
                    `;

                    couponContainer.appendChild(couponItem)
                });
            } else {
                couponContainer.style.display = 'none';
            }
        }

        function renderEmptyCart() {
            // empty the cart so we can repopulate from scratch
            cartContainer.innerHTML = null;
            couponContainer.style.display = 'none';
        }

        function renderCartItem(item) {
            let product = item.getProduct();

            if (!product) {
                return;
            }

            let productAdditionalFieldInfo = renderCartItemAdditionalFields(item);

            const newItem = document.createElement('div')
            newItem.classList.add('kl-cart-item')
            newItem.dataset.id = item.getProduct()

            // add this item to the cart HTML
            cartContainer.appendChild(newItem);

            const width =
                window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth;

            // @TODO Combine these and use css to show/hide so we don't need
            //       to redraw it when the page is resized
            // @TODO Also the quantity arrows are never showing and aren't hooked up - sort that out
            if (width > 767) {
                newItem.innerHTML = `
                        <div class="kl-cart-info">
                          <div class="kl-cart-product">
                            <div class="kl-cart-image">
                              <img
                                width="132"
                                height="332"
                                src="${product.imageUrl}"
                                alt=""
                              />
                            </div>
                            <div class="kl-cart-name">
                              <p>${product.name}</p>
                              
                              ${productAdditionalFieldInfo}
                            </div>
                          </div>
                          <div class="kl-cart-price">
                            <p>£${product.price}</p>
                          </div>
                          <div class="kl-cart-quantity">
                            <div class="kl-cart-quantity-container">
                              <div class="kl-cart-minus minus" style="${true || product.isSubscription ? 'display: none' : ''}">
                                <img
                                  src="/wp-content/uploads/2024/03/sub.svg"
                                  alt=""
                                  class="minus"
                                />
                              </div>
                              <div class="kl-cart-quantity-num">${item.quantity}</div>
                              <div class="kl-cart-plus plus" style="${true || product.isSubscription ? 'display: none' : ''}">
                                <img
                                  src="/wp-content/uploads/2024/03/ic_sharp-plus.svg"
                                  alt=""
                                  class="plus"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="kl-cart-total">
                            <p>£${product.price * item.quantity}</p>
                            <p class="kl-cart-remove js-remove" data-id="${item.uid}">Remove</button>
                          </div>
                        </div> `
            } else {
                newItem.innerHTML = `
                      <div class="kl-cart-info">
                        <div class="kl-cart-product">
                            <div class="kl-cart-image">
                              <img
                                width="132"
                                height="332"
                                src="${product.imageUrl}"
                                alt=""
                              />
                            </div>
                            <div class="kl-cart-product-info">
                              <div class="kl-cart-name">
                                <p>${product.name}</p>
                                
                                ${productAdditionalFieldInfo}
                                
                                <div class="kl-cart-remove js-remove" data-id="${item.uid}">
                                  <img
                                    class="js-remove"
                                    width="32"
                                    height="32"
                                    src="/wp-content/uploads/2023/10/Cross.svg"
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div class="kl-cart-price">
                                <p>Price: £${product.price}</p>
                              </div>
                              <div class="kl-cart-quantity-wrapper">
                                <div class="kl-cart-quantity">
                                  <div class="kl-cart-quantity-container">
                                    <div class="kl-cart-minus minus" style="${product.isSubscription ? 'display: none' : ''}">
                                      <img
                                        src="/wp-content/uploads/2024/03/sub.svg"
                                        alt=""
                                        class="minus"
                                      />
                                    </div>
                                    <div class="kl-cart-quantity-num">${item.quantity}</div>
                                    <div class="kl-cart-plus plus" style="${product.isSubscription ? 'display: none' : ''}">
                                      <img
                                        src="/wp-content/uploads/2024/03/ic_sharp-plus.svg"
                                        alt=""
                                        class="plus"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="kl-cart-total">
                                  <p>£${product.price * item.quantity}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                     </div> `
            }
        }

        function renderCartItemAdditionalFields(item) {
            let html = '';

            let additionalFields = item.getAdditionalFields();

            if (additionalFields.length === 0) {
                // nothing to show
                return html;
            }

            html = '<ul>';

            for (const [key, value] of Object.entries(additionalFields)) {
                if (!value.length) {
                    continue;
                }

                html += `<li>${key}: ${value}</li>`;
            }

            return '</ul>' + html;
        }

        // renders the cart table
        function renderCart() {
            renderCartHeader();
            renderEmptyCart();

            if (window.cart.isEmpty()) {
                // if we have an empty cart then we don't need to do anything
                return;
            }

            // add each cart item to the table
            window.cart.items.forEach(renderCartItem);

            renderCartDiscounts();
        }






        // initialise the page
        function initCartPage() {
            renderCart()
        }

        initCartPage();
    });
})( jQuery );